// Module
var code = " <template><require from=\"./md-icon-stack.scss\"></require><slot></slot></template> ";
// Exports
module.exports = code;